"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  border: ", ";\n  border-radius: ", ";\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  font-size: 1em;\n  font-style: normal;\n  text-decoration: none;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n\n  :hover,\n  :active {\n    box-shadow: ", ";\n  }\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  svg {\n    width: 1em;\n    height: 1em;\n    fill: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// TODO: Need better mechanism to get focus indicator color. Right now, it uses
// the regular, dark focus indicator unless it's a light color with a flat or
// outlined style button, in which case it's assumed that the button needs to be
// on a dark background and needs the lighter focusIndicatorContrast style.
var getFocusIndicator = function getFocusIndicator(props) {
  var flat = props.flat,
      outlined = props.outlined,
      color = props.color,
      theme = props.theme;

  if (flat || outlined) {
    if (color === 'primaryLight' || color === 'neutralLight') {
      return theme.focusIndicatorContrast;
    }
  }

  return theme.focusIndicator;
};

var Root = _styledComponents.default.button(_templateObject(), function (props) {
  return props.flat ? '0.75rem' : '0.75rem 1rem';
}, function (props) {
  return props.flat ? 'none' : "1px solid ".concat((0, _Theme.getThemeVariable)('color')(props));
}, function (props) {
  return props.rounded ? '4px' : '0';
}, function (props) {
  return props.flat || props.outlined ? 'transparent' : (0, _Theme.getThemeVariable)('color')(props);
}, function (props) {
  return props.flat || props.outlined ? (0, _Theme.getThemeVariable)('color')(props) : (0, _Theme.getThemeVariable)('colorText')(props);
}, function (props) {
  return props.raised && !props.disabled ? '0 1px 3px 0 rgba(0, 0, 0, 0.1)' : 'none';
}, function (props) {
  return props.disabled ? '0.35' : '1';
}, function (props) {
  return props.disabled ? 'none' : 'auto';
}, function (props) {
  return props.raised && !props.disabled ? '0 1px 3px rgba(0, 0, 0, 0.4)' : 'none';
}, getFocusIndicator, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.flat || props.outlined ? (0, _Theme.getThemeVariable)('color')(props) : (0, _Theme.getThemeVariable)('colorText')(props);
});

var Child = _styledComponents.default.div(_templateObject2());

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          href = _this$props.href,
          render = _this$props.render,
          otherProps = _objectWithoutProperties(_this$props, ["className", "disabled", "href", "render"]);

      var ariaProps = href || otherProps.to ? {
        role: 'button',
        'aria-disabled': disabled
      } : {}; // Wrap all children in a div to allow setting margin on text nodes

      var children = _react.default.Children.map(this.props.children, function (child, index) {
        return _react.default.createElement(Child, {
          key: index
        }, child);
      });

      var props = _objectSpread({
        className: (0, _classnames.default)('hw-button', className),
        disabled: disabled,
        href: href
      }, ariaProps, {}, otherProps);

      if (render) {
        return render(_objectSpread({}, props, {
          children: children
        }));
      } else if (href) {
        return _react.default.createElement(Root, _extends({
          as: "a"
        }, props), children);
      } else {
        return _react.default.createElement(Root, props, children);
      }
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  render: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  flat: _propTypes.default.bool,
  href: _propTypes.default.string,
  id: _propTypes.default.string,
  outlined: _propTypes.default.bool,
  raised: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  color: _propTypes.default.oneOf(['primary', 'primaryLight', 'primaryDark', 'primaryDarker', 'accent', 'accentDark', 'neutral', 'neutralLight', 'neutralDark']),
  theme: _propTypes.default.shape({
    colorPrimaryLight: _propTypes.default.string,
    colorPrimary: _propTypes.default.string,
    colorPrimaryDark: _propTypes.default.string,
    colorPrimaryDarker: _propTypes.default.string,
    colorAccent: _propTypes.default.string,
    colorAccentDark: _propTypes.default.string,
    colorNeutralLight: _propTypes.default.string,
    colorNeutral: _propTypes.default.string,
    colorNeutralDark: _propTypes.default.string,
    colorTextOnPrimaryLight: _propTypes.default.string,
    colorTextOnPrimary: _propTypes.default.string,
    colorTextOnPrimaryDark: _propTypes.default.string,
    colorTextOnPrimaryDarker: _propTypes.default.string,
    colorTextOnAccent: _propTypes.default.string,
    colorTextOnAccentDark: _propTypes.default.string,
    colorTextOnNeutralLight: _propTypes.default.string,
    colorTextOnNeutral: _propTypes.default.string,
    colorTextOnNeutralDark: _propTypes.default.string,
    focusIndicator: _propTypes.default.string,
    focusIndicatorContrast: _propTypes.default.string,
    focusIndicatorOffset: _propTypes.default.string
  }),
  type: _propTypes.default.oneOf(['button', 'submit', 'reset'])
};
Button.defaultProps = {
  color: 'primary',
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Button);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Button/index.js